import { version } from "../../package.json";

// CI injects the build version and commit; local builds fall back to package.json.
const buildVersion = import.meta.env.VITE_APP_VERSION?.trim() || version;
const commit = import.meta.env.VITE_APP_COMMIT?.trim().slice(0, 7);

export const appVersion = commit ? `${buildVersion} (${commit})` : buildVersion;
